import postMessage from './postMessage'

export const getInitData = postMessage
